import { IElement } from "core-integration/src/store/elements/types";
import React from "react";
import styled, { css } from "styled-components";

const ElementWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
`;

const ElementName = styled.div<IStyledProps>`
  padding: 0.3rem 0.2rem;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1rem;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  ${(props) =>
    props.element.news &&
    props.element.chance_of_playing_next_round !== null &&
    css`
      background-color: ${
        props.theme.colors.elementStatus[
          props.element.chance_of_playing_next_round
        ].bg
      };
      color: ${
        props.theme.colors.elementStatus[
          props.element.chance_of_playing_next_round
        ].color
      };
    `}

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    font-size: ${({ theme }) => theme.fontSizes[1]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    padding-top: 0.45rem;
    padding-bottom: 0.35rem;
    font-size: ${({ theme }) => theme.fontSizes[2]};
  }
`;

const ElementValue = styled.div`
  padding: 0.2rem 0.3rem;
  border-bottom-left-radius: ${({ theme }) => theme.radii[1]};
  border-bottom-right-radius: ${({ theme }) => theme.radii[1]};
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  font-size: 1rem;
  font-weight: 800;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    padding-top: 0.3rem;
    padding-bottom: 0.2rem;
    font-size: ${({ theme }) => theme.fontSizes[1]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    padding-top: 0.45rem;
    padding-bottom: 0.4rem;
    font-size: ${({ theme }) => theme.fontSizes[1]};
  }
`;

interface IStyledProps {
  element: IElement;
}

interface IProps {
  value: React.ReactNode;
}

type Props = IStyledProps & IProps;

const PitchElementData: React.FC<Props> = ({ element, value }) => (
  <ElementWrapper>
    <ElementName element={element}>{element.web_name}</ElementName>
    <ElementValue>{value}</ElementValue>
  </ElementWrapper>
);

export default PitchElementData;
